/* eslint-disable react/no-unused-class-component-methods */
'use strict';

import React, { Component, useEffect } from 'react'

import DeleteUserConfirmationModal from '@Modal/DeleteUserConfirmationModal'
import CreateAbondementModal       from '@Modal/CreateAbondementModal'
import UpdateAbondementModal       from '@Modal/UpdateAbondementModal'
import UserDisabledDateModal       from '@Modal/UserDisabledDateModal'
import ValidateUserModal           from '@Modal/ValidateUserModal'
import UserCardModal               from '@Modal/UserCardModal'
import UserRefModal                from '@Modal/UserRefModal'
import DeleteModal                 from '@Modal/DeleteModal'
import CartModal                   from '@Modal/CartModal'
import MobileAppModal              from '@Modal/MobileAppModal'

import GlobalSearchResults from '@/GlobalSearchResults'
import PageTitle           from '@/PageTitle'

import HolidaysMessage from '@/HolidaysMessage'

import EcRenewalWarning from '@/Billing/EcRenewalWarning'

import request from '@function/ajax/request'

import Header from '@Navigation/UserHeader'

import EcNotRenewedWarning from './EcNotRenewedWarning'

const app = window.app;

export default class ECFront extends Component
{
	constructor (props)
	{
		super(props);

		app.router_history = this.props.history;

	// eslint-disable-next-line react/state-in-constructor
		this.state = { permissions: { title: 'not_auth' } };
	}

	componentDidMount ()
	{
		const component = this, props = this.props, state = this.state;

		component.handleSessionChange();

		app.push(
		{
			event: 'sessionChange',
			cb: component.handleSessionChange
		});

		component.getSorewardsStatus();
	}

	componentWillUnmount ()
	{
		const component = this, props = this.props, state = this.state;

		app.delete(
		{
			event: 'sessionChange',
			cb: component.handleSessionChange
		});
	}

	getSorewardsStatus = () =>
	{
		const component = this, props = this.props, state = this.state;

		(async function ()
		{
			try
			{
				var { card_exists } = await request('/sorewards/get-user-status')
				.config({ })
				.post({ });
			}
			catch (e)
			{
				card_exists = false;
			}

			component.setState({ sorewards: card_exists });
		})();
	}

	handleSessionChange = () =>
	{
		const component = this, props = this.props, state = this.state;

		if (!app.state.session?.permissions) return;

		const update = { permissions: app.state.session.permissions };

		if (!state.mobile_app_modal)
		{
			if ([true,'true'].includes(app.state.session?.show_mobile_app_modal))
			{
				update.mobile_app_modal = { open: true };

				app.state.session.show_mobile_app_modal = false;
			}
			else
			{
				update.mobile_app_modal = { open: false };
			}
		}

		component.setState(update);
	}

	closeMobileAppModal = () => this.setState({ mobile_app_modal: { } });

	documentClick = () =>
	{
		app.emit('documentClick', 'layout');
	}

	render ()
	{
		const component = this, props = this.props, state = this.state;

		const role = state.permissions?.title;

		const output =
		(
			<div className="page-wrapper" onClick={ component.documentClick }>

				<Header history={ props.history }
					permissions={ state.permissions }
					sorewards={ state.sorewards }
				/>

				<div className="page">

					<div className={ 'page-body' +
						(props.show_scroll ? ' u-scroll-y' : '') }>

						<GlobalSearchResults />

						{
							props.hide_title && props.hide_breadcrumb ? null :
							(
								<PageTitle history={ props.history }
									title={ props.page_title }
									hide_title={ props.hide_title }
									hide_breadcrumb={ props.hide_breadcrumb }
								/>
							)
						}

						<HolidaysMessage from-header />

						{
							['EC', 'Administrateur de CE'].includes(role) ?
							(
								<EcRenewalWarning />
							)
							: undefined
						}

						{
							!['Membre de Synergies'].includes(role) ?
							(
								<EcNotRenewedWarning />
							)
							: undefined
						}

						{ props.children }

						<footer className="footer">

							<a href="https://www.synergies.site/mentions-legales.php"
								target="_blank" rel="noreferrer">
								Mentions légales
							</a>

							<a href="https://www.synergies.site/pdf/politique-rgpd-synergies.pdf"
								target="_blank" rel="noreferrer"
								className="u-margin-left-15">
								Politique RGPD
							</a>

							<a href="/documents/CGU_v10_10_2019.pdf"
								target="_blank" className="u-margin-left-15">
								Conditions générales d'utilisation
							</a>

							<a href="/documents/CGV_v_17_03_20.pdf"
								target="_blank" className="u-margin-left-15">
								Conditions générales de vente
							</a>

						</footer>

					</div>

					<DeleteModal />
					<ValidateUserModal />
					<DeleteUserConfirmationModal />
					<CartModal />
					<CreateAbondementModal />
					<UpdateAbondementModal />
					<UserRefModal />
					<UserDisabledDateModal />
					<UserCardModal />

				</div>

				<MobileAppModal open={ state.mobile_app_modal?.open === true }
					onClose={ component.closeMobileAppModal }
				/>

			</div>
		);

		return output;
	}
}